import { isEqual } from 'lodash';
import { FILTERS } from '@/constants';
import { SearchFilterState } from '@/store/types';
import { Schools } from '#server/models/school-staff-unit';

export const updateFilters = (
  schoolList: Schools[],
  selectedSchoolId: number,
  activeYear: number,
  searchFilters: SearchFilterState,
  setSelectedSchoolId: (id: number) => void,
  setSearchFilters: (filters: SearchFilterState) => void,
) => {
  if (!selectedSchoolId && schoolList) {
    const updatedFilters: SearchFilterState = {
      ...searchFilters,
      [FILTERS.YEAR]: { value: activeYear, label: activeYear.toString() },
    };

    if (schoolList.length > 0 && !updatedFilters[FILTERS.SCHOOL]) {
      const defaultSchoolId = schoolList[0]!.id;
      const defaultSchoolName = schoolList[0]!.name;
      setSelectedSchoolId(defaultSchoolId);
      updatedFilters[FILTERS.SCHOOL] = { value: defaultSchoolId, label: defaultSchoolName };
    }

    // Only update filters if they actually changed
    if (!isEqual(searchFilters, updatedFilters)) {
      setSearchFilters(updatedFilters);
    }
  }
};
